import config from '@config'
import { encodeGetParams, errorHandler } from '@ota-frontend/core/helpers/url'
import { SearchCondition } from '@/models'

export const fetchBff = (path, query, headers = {}) => {
  if (!headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }
  const url = [config.api.bffBaseUrl, '/', path].join('')
  return fetch(url + `?${encodeGetParams(query)}`, {
    headers: headers,
  })
    .then((resp) => resp.json())
    .catch((e) => errorHandler('fetchBff', e))
}

export const fetchTourLpInitialDisplay = (condition, lpName) => {
  return fetchBff('tour/lp/initial-display', {
    ...buildTourQueryFromSearchCondition(condition),
    lp_name_en: lpName,
  })
}

export const fetchTourLpFacets = (condition) => {
  return fetchBff('tour/list/facets', buildTourQueryFromSearchCondition(condition))
}

export const fetchTourLpMoreTours = (condition, start) => {
  return fetchBff('tour/list/more-tours', {
    ...buildTourQueryFromSearchCondition(condition),
    start: start,
  })
}

// TODO: fetchBff をリファクタする際に各エンドポイント用のメソッド・関数に組み込み、外から利用する必要が無いようにする
export const buildTourQueryFromSearchCondition = condition => (destinations => compactObject({
  condition_flg: condition.searchType,
  domestic: condition.rawDomestic,
  departure_place_id: condition.departurePlaceId,
  region_id: destinations[0].regionId,
  country_id: destinations[0].countryId,
  city_id: destinations[0].cityId,
  district_id: destinations[0].districtId,
  region_id2: destinations[1].regionId,
  country_id2: destinations[1].countryId,
  city_id2: destinations[1].cityId,
  district_id2: destinations[1].districtId,
  region_id3: destinations[2].regionId,
  country_id3: destinations[2].countryId,
  city_id3: destinations[2].cityId,
  district_id3: destinations[2].districtId,
  region_id4: destinations[3].regionId,
  country_id4: destinations[3].countryId,
  city_id4: destinations[3].cityId,
  district_id4: destinations[3].districtId,
  'y-m': (condition.departureDateAsIsoFormat || '').slice(0, 7),
  d: (condition.departureDateAsIsoFormat || '').slice(8, 10),
  duration_from: condition.durationFrom,
  duration_to: condition.durationTo,
  passenger_count: condition.numberOfPassengers,
  campaign_ids: condition.campaignIds.join(','),
  keyword: condition.keyword,
  price_from: condition.priceFrom,
  price_to: condition.priceTo,
  intention_ids: condition.groupedIntentionIds.map(idsOfName => idsOfName.join('-')).join(','),
  hotel_important_level: condition.minHotelRank,
  hotel_id: [
    ...destinations[0].hotelIds,
    ...destinations[1].hotelIds,
    ...destinations[2].hotelIds,
    ...destinations[3].hotelIds,
  ].join(','),
  stopover_flg: condition.preferDirectFlight ? '0': undefined,
  train: condition.trainIds[0],
  airline_id: condition.airlineIds.join(','),
  seat_code: condition.seatCode,
  departure_place_time_code: condition.departurePlaceTimeCode,
  destination_arrival_time_code: condition.destinationArrivalTimeCode,
  destination_time_code: condition.destinationTimeCode,
  departure_place_arrival_time_code: condition.departurePlaceArrivalTimeCode,

  // 呼び出し側でデフォルト指定できるようにした方が良いかもしれない
  order: condition.order || SearchCondition.ORDERS[0].code,
  vc_code: condition.code,
}))(condition.destinations)

const compactObject = obj => Object.fromEntries(
  Object.entries(obj).filter(([k, v]) => Array.isArray(v)
    ? v.length > 0
    : !!v || v === 0 || v === false),
)
